// A provider may resolve after our UI deadline. Dispose that late room rather
// than leaving a connected microphone behind an already failed join screen.
export function connectWithDeadline(connect, { timeoutMs, onLateRoom, onTimeout }) {
  return new Promise((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      settled = true;
      try { onTimeout?.(); } catch { /* Keep the failure path available if a device stop throws. */ }
      const error = new Error('Consultation connection timed out. Please try joining again.');
      error.code = 'consultation_media_unavailable';
      reject(error);
    }, timeoutMs);
    Promise.resolve().then(connect).then((room) => {
      if (settled) { try { onLateRoom?.(room); } catch { /* Disposal cannot change the settled join result. */ } return; }
      settled = true;
      clearTimeout(timer);
      resolve(room);
    }, (error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      reject(error);
    });
  });
}
